import { FC, useState } from 'react';
import { HStack } from '@chakra-ui/react';

import Button from 'components/_core/Button';
import Heading from 'components/_core/Heading';
import IconButton from 'components/_core/IconButton';
import Text from 'components/_core/Text';
import PasscodeInput from 'components/PasscodeInput';
import { ClearAllDigitsFn } from 'components/PasscodeInput/types';

import NavigationHeader from '../../../../../../components/NavigationHeader';
import SidebarFooter from '../../components/SidebarFooter';
import locales from './locales';

interface UpdatePinEditConfirmProps {
  creditCardId: string;
  onSubmit: (pinCodeConfirm: string, clearAllDigits: ClearAllDigitsFn) => void;
}

const UpdatePinEditConfirm: FC<UpdatePinEditConfirmProps> = ({
  creditCardId,
  onSubmit,
}) => {
  const [isPinShown, setIsPinShown] = useState(false);

  return (
    <>
      <NavigationHeader backTo={`/cards/${creditCardId}`} />

      <Heading marginBottom="space-16">{locales.title}</Heading>
      <Text marginBottom="space-32">{locales.description}</Text>

      <HStack>
        <PasscodeInput hidden={!isPinShown} length={4} onSubmit={onSubmit} />
        <IconButton
          aria-label={isPinShown ? locales.hidePin : locales.showPin}
          icon={isPinShown ? 'eye-close' : 'eye-open'}
          onClick={() => setIsPinShown(!isPinShown)}
          title={isPinShown ? locales.hidePin : locales.showPin}
          variant="inline-primary"
        />
      </HStack>

      <SidebarFooter>
        <Button isDisabled width="100%">
          {locales.cta}
        </Button>
      </SidebarFooter>
    </>
  );
};

export default UpdatePinEditConfirm;
